import { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  DeleteFlexValue,
  GetFlexValue,
  insertFlexValue,
} from '../../../../../store/NTX/FlexValue/FlixValueSlice';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import CustomAlert from '../../../../../components/Shared/Alert/CustomAlert';
import showConfirmation from '../../../../../components/Shared/Alert/Confirmation';
import NtxTable from '../../../../../components/DataTable/NtxTable';
import Loading from '../../../../../components/Shared/Loader/Loading';

const AddFlexValue = ({ id }) => {
  const { t, i18n } = useTranslation();
  // const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetFlexValue(id));
  }, [dispatch, id]);
  const { FlexValueList, loading, error } = useSelector((state) => state.FlexValue);
  const data = FlexValueList && FlexValueList?.filter((f) => f.parentId === null);

  const formik = useFormik({
    initialValues: {
      name2: '',
      name: '',
      parentId: null,
      imgUrl: '',
    },
    // validationSchema: formJob(t),
    onSubmit: (values, { resetForm }) => {
      dispatch(
        insertFlexValue({
          flexValueSetId: id,
          name2: values.name2,
          name: values.name,
          parentId: null,
          imgUrl: values.imgUrl,
          enabledFlag: true,
        })
      )
        .unwrap()
        .then(() => {
          CustomAlert({ action: 'Add' });
          resetForm();
        })
        .catch((error) => {
          console.log(error);
          CustomAlert({ action: 'Error' });
        });
    },
    validate: (values) => {
      const errors = {};
      if (!values.name) {
        errors.selectValue = 'مطلوب';
      }
      if (!values.name2) {
        errors.textValue = 'مطلوب';
      }
      return errors;
    },
  });

  // ______ handle Delete Flex Value
  const handleDeleteFlexValue = (item) => {
    showConfirmation(t('MsgConfirm'), () => {
      dispatch(DeleteFlexValue(item.id))
        .unwrap()
        .then(() => {
          dispatch(GetFlexValue(id));
          CustomAlert({ action: 'Delete' });
        })
        .catch((error) => {
          console.log(error);
          CustomAlert({ action: 'Error' });
        });
    });
  };

  //________________________________

  const columns = [
    { title: t('Value'), key: 'Value' },
    { title: t(''), key: 'action', className: 'text-end  ' },
  ];

  const tableData = data?.map((item) => {
    let rowClass;

    return {
      Value: i18n.language === 'en' ? item.name : item.name2,

      action: (
        <button
          type="button"
          className="btn btn-outline-danger m-0"
          onClick={() => handleDeleteFlexValue(item)}>
          <i className="fas fa-trash-alt fa-fw fa-lg"></i>
        </button>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });

  return (
    <>
      <Loading loading={loading} error={error} Type="Dots">
        <Form onSubmit={formik.handleSubmit}>
          <div className="row align-items-end">
            <div className="col-xl-4">
              <div className="form-group mb-3">
                <label className="form-label">{t('LocalName')}</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="name2"
                  onChange={formik.handleChange}
                  value={formik.values.name2}
                  isInvalid={!!formik.errors.name2}
                  required
                />
              </div>
            </div>

            <div className="col-xl-4">
              <div className="form-group mb-3">
                <label className="form-label">{t('GlobalName')}</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="name"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  isInvalid={!!formik.errors.name}
                  required
                />
              </div>
            </div>

            <div className="col-xl-4 text-end  ">
              <div className=" form-group mb-3 d-flex justify-content-end ">
                <button
                  disabled={formik.isSubmitting}
                  type="submit"
                  className="btn me-1 btn-theme w-50">
                  {formik.isSubmitting ? (
                    <div className="spinner-border spinner-border-sm me-2"></div>
                  ) : (
                    <i className="fas fa-lg fa-fw me-2 fa-plus"></i>
                  )}
                  {t('Add')}
                </button>
                <button
                  type="button"
                  className=" btn me-1 btn-default w-50"
                  data-bs-dismiss="modal">
                  <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
                </button>
              </div>
            </div>
          </div>
        </Form>

        <NtxTable
          data={tableData || []}
          columns={columns}
          dataPerPage={5}
          theadClass=""
          tableClass="table text-nowrap table-hover "
          // enableSearch
          // showRecordsSelector
        />
      </Loading>
    </>
  );
};

export default AddFlexValue;

//  {/* <div className="col-xl-4">
//       <div className="form-group mb-3">
//         <label className="form-label">{t("Choose photo")}</label>
//         <Form.Control
//           type="file"
//           className="form-control"
//           placeholder=" أختر صورة"
//           name="imgUrl"
//           accept="image/*"
//           onChange={(e) => setSelectedFile(e.target.files[0])}
//         />
//       </div>
//     </div> */}
// {/* <div className="col-xl-3">
//         {selectedFile && (
//           <div className="mb-0">
//             <Card>
//               <CardBody>
//                 <img
//                   src={URL.createObjectURL(selectedFile)}
//                   alt="Attachment Preview"
//                   style={{ maxWidth: "100%", maxHeight: "290px" }}
//                 />
//               </CardBody>
//             </Card>
//           </div>
//         )}
//       </div> */}
